import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MotoresRoutingModule } from './motores-routing.module';
import { CoreModule } from '../../core/core.module';
import { CoreModule as SubCoreModule } from './seguros/core/core.module';
import { SegurosComponent } from './seguros/seguros.component';
import { VuelosComponent } from './vuelos/vuelos.component';
import { Page404Component } from './components/page404/page404.component';
import { HeaderComponent } from './components/header/header.component';

import { WidgetInsuranceWebModule } from '../general-components/widget-insurance-web/widget-insurance-web.module';

@NgModule({
  imports: [
    CommonModule,
    MotoresRoutingModule,
    CoreModule,
    WidgetInsuranceWebModule,
    // BrowserModule,
    // BsDropdownModule.forRoot(),
    // AlertModule.forRoot(),
    // HttpClientModule
  ],
  declarations: [
    SegurosComponent,
    VuelosComponent,
    Page404Component,
    HeaderComponent,
    
  ]
})
export class MotoresModule { }
